import { render, staticRenderFns } from "./ViewSaleReturnItem.vue?vue&type=template&id=0810a9fc&scoped=true&"
import script from "./ViewSaleReturnItem.vue?vue&type=script&lang=js&"
export * from "./ViewSaleReturnItem.vue?vue&type=script&lang=js&"
import style0 from "./ViewSaleReturnItem.vue?vue&type=style&index=0&id=0810a9fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0810a9fc",
  null
  
)

export default component.exports